import { useEffect } from 'react'
import { create } from 'zustand'

interface PageHeaderState {
  title: string
  subtitle: string
  setPageHeader: (title: string, subtitle: string) => void
  clear: () => void
}

export const usePageHeaderStore = create<PageHeaderState>((set) => ({
  title: '',
  subtitle: '',
  setPageHeader: (title, subtitle) => set({ title, subtitle }),
  clear: () => set({ title: '', subtitle: '' }),
}))

/**
 * Hook que cada página chama pra publicar seu titulo/subtitulo no header global.
 * Limpa automaticamente no unmount pra evitar flash de titulo antigo ao trocar de rota.
 */
export function usePageHeader(title: string, subtitle: string) {
  const setPageHeader = usePageHeaderStore((s) => s.setPageHeader)
  const clear = usePageHeaderStore((s) => s.clear)

  useEffect(() => {
    setPageHeader(title, subtitle)
    return () => clear()
  }, [title, subtitle, setPageHeader, clear])
}
